"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var DefaultQRCodeContentProviderService = /** @class */ (function () {
    function DefaultQRCodeContentProviderService() {
        this.ENCODED_QUESTION_MARK = '?';
    }
    DefaultQRCodeContentProviderService.prototype.qrGenerationOptions = function (category) {
        return Observable_1.Observable.of(['ejustice_current_url']);
    };
    DefaultQRCodeContentProviderService.prototype.getQRProperties = function (propertyKey, category, entity) {
        if (!propertyKey || propertyKey === 'ejustice_current_url') {
            return Observable_1.Observable.of({
                content: this.getFormattedLocationHref()
            });
        }
    };
    DefaultQRCodeContentProviderService.prototype.getFormattedLocationHref = function () {
        var locationHref = location.href;
        var startIndex = locationHref.indexOf(this.ENCODED_QUESTION_MARK);
        while (startIndex !== -1) {
            var endIndex = locationHref.indexOf('/', startIndex);
            locationHref = locationHref.substring(0, startIndex) + (endIndex !== -1 ? locationHref.substring(endIndex) : '');
            startIndex = locationHref.indexOf(this.ENCODED_QUESTION_MARK);
        }
        return locationHref;
    };
    DefaultQRCodeContentProviderService = __decorate([
        core_1.Injectable()
    ], DefaultQRCodeContentProviderService);
    return DefaultQRCodeContentProviderService;
}());
exports.DefaultQRCodeContentProviderService = DefaultQRCodeContentProviderService;
//# sourceMappingURL=default-qr-code-content-provider.service.js.map